/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Popper from '@material-ui/core/Popper';
import { makeStyles } from '@material-ui/core/styles';
import styles from '../../../../styles/general.module.scss';
import { renderInfoForType } from '../../../../utils/helpers';
import Modal from '../../../../components/modal/modal';
import Scheduling from '../../Scheduling/Scheduling';
import Button from '../../../../components/button/button';
import styles1 from '../authentication.module.scss';
import { isLocal, hostName } from '../../../../constants/apiEnv';


const useStyles = makeStyles(theme => ({
  paper: {
    border: '1px solid #E6EAEE',
    width: '122px',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    cursor: 'pointer'
  }
}));

const SchedulingList = (props) => {
  const { data, onCancelSuccess, onRescheduleSuccess } = props;
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [id, setid] = useState('');
    const [cancelModal, setCancelModal] = useState(false);
    const [rescheduleModal, setRescheduleModal] = useState(false);
    const [scheduleId, SetRescheduleId] = useState(null);
    const [cancelMessage, setCancelMessage] = useState('');
    const [cancelError, setCancelError] = useState(false);
    const [apiSuccessMsg, handleApiStatus] = useState({ apiSuccess: false, loading: false });
    const { match: { params: { airportCode } } } = props;
    const url = hostName.slice(6);
    const installationId = localStorage.getItem('installationId') || 'us';
    const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${installationId}${url}/public`;
    const closePopper = () => setAnchorEl(null);

    const handleClick = (event, clickId) => {
      setAnchorEl(anchorEl ? null : event.currentTarget);
      setid(clickId);
    };
    const open = Boolean(anchorEl);
    const ids = open ? 'simple-popper' : undefined;

    const cancleSchedule = () => {
      setCancelModal(true);
    };
    const handleReschedule = (Id) => {
      setRescheduleModal(true);
      SetRescheduleId(Id);
    };
    const handleCancellation = async (cancelId) => {
      if (cancelMessage?.length === 0) {
        setCancelError(true);
        return;
      }
      let payload = {
        'status': 'cancel',
        'reason_for_cancelling': cancelMessage
      };

      try {
        handleApiStatus({ ...apiSuccessMsg, loading: true });
        if (onCancelSuccess) {
        onCancelSuccess(cancelId);
        }
        await fetch(`${publicUrl}/scheduling/booking/${airportCode}/badging/${cancelId}/`, {
          method: 'PATCH',
          body: JSON.stringify(payload),
          headers: { 'Content-Type': 'application/json' }
        });
        handleApiStatus({
          apiSuccess: true
        });
      } catch (error) {
        handleApiStatus({ apiSuccessMessage: 'There was a problem while retrieving the form' });
      }
      setCancelError(false);
      setCancelModal(false);
    };
  const selectedSchedule = data?.find(item => item.id === id);
  const visibleList = data.filter(item => item.status !== 'cancel');

  return (
    <div style={{ width: '100%' }}>
        <>
          <h3 style={{ color: 'white', marginLeft: '13%', marginTop: '3%' }}>Scheduled Appointements</h3>
          <table className={styles.table} style={{ margin: 'auto', marginBottom: '3%', width: '75%' }}>
            <thead>
              <tr style={{ background: 'rgb(233,239,244)', whiteSpace: 'pre' }}>
                <th style={{ color: 'rgba(50, 51, 102, 1)' }}>
                  <FormattedMessage id="module.id" defaultMessage="Full Name" />
                </th>
                <th style={{ color: 'rgba(50, 51, 102, 1)' }}>
                  <FormattedMessage id="module.id" defaultMessage="Date & Time" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
                {visibleList.length > 0
                ? visibleList?.map(list => (
                  <tr>
                    <td style={{ color: 'rgba(50, 51, 102, 1)' }}>{`${list.first_name} ${list.last_name}`}</td>
                    <td style={{ color: 'rgba(50, 51, 102, 1)' }}>
                        {renderInfoForType({ 'type': 'date' }, list.start_ts, null, null)}
                        {' '} at {' '}
                        {renderInfoForType({ 'type': 'time' }, list.start_ts, null, null)}
                    </td>
                    <td>
                      <div>
                          <button
                          aria-describedby={ids}
                          style={{ background: 'white', outline: 'none', border: 'none' }}
                          type="button"
                          onClick={(event) => { handleClick(event, list.id); }}
                          >
                            Actions
                          </button>
                          <Popper id={ids} open={open} anchorEl={anchorEl}>
                            <div className={classes.paper} onClick={() => cancleSchedule()}>
                              <FormattedMessage id="inspections.new.cancelBtn" defaultMessage="Cancel" />
                            </div>
                            <div className={classes.paper}
                            onClick={() => handleReschedule(list?.id)}
                            >
                            <FormattedMessage id="assets.deletess" defaultMessage="Reschedule" />
                            </div>
                          </Popper>
                      </div>
                    </td>
                  </tr>))
                : <tr><td>No scheduled appointments found.</td></tr>
                }
            </tbody>
          </table>
          {cancelModal && (
            <Modal
            width="650px"
            showIn={cancelModal}
            onClose={() => { setCancelModal(false); setCancelMessage(''); setCancelError(false); }}
            contentStyles={{
                overflowY: 'auto', minHeight: '23%'
            }}
            >
            <div className={styles1.newTask}>
                  <div style={{ margin: '20px' }}>
                  <textarea style={{ width: '100%', height: '80px' }}
                  onChange={e => setCancelMessage(e.target.value)}
                  placeholder="Reason for cancelling the scheduling…"
                  />
                  {cancelError && (
                    <div style={{ color: 'red', marginTop: '5px' }}>
                      This field is required.
                    </div>
                  )}
                  </div>
                  <div className={styles1.notefooter} style={{ justifyContent: 'flexEnd', gap: '3%' }}>
                    <Button
                      action="default"
                      className={styles1.importbtn}
                      onClick={() => { setCancelModal(false); closePopper(); setCancelMessage(''); setCancelError(false); }}
                      translationID="todo.newTask.cancellll"
                      defaultText="No"
                    />
                    <div className={styles1.saveWrapper1}>
                      <Button
                        onClick={() => { handleCancellation(id); closePopper(); }}
                        translationID="lease.maintenance.detail.status_mark_rejectedddd"
                        defaultText="Yes, Cancel"
                        action="danger"
                      />
                    </div>
                  </div>
            </div>
            </Modal>
          )}
          {rescheduleModal && scheduleId && (
            <Modal
            width="943px"
            showIn={rescheduleModal}
            onClose={() => { setRescheduleModal(false); closePopper(); }}
            contentStyles={{
                overflowY: 'auto', height: 'auto'
            }}
            >
            <div>
                <Scheduling
                applicationData={selectedSchedule}
                Reschedule
                onRescheduleSuccess={onRescheduleSuccess}
                onClose={() => {
                  setRescheduleModal(false);
                  closePopper();
                }}
                />
            </div>
            </Modal>
          )}
        </>
    </div>
  );
};
export default withRouter(SchedulingList);
